import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { CustomCategoryGridEffects } from '../grid-custom-category/store/custom-category-grid.effects';

import { GridDefault2Component } from './components/grid-default-2/grid-default-2.component';
import { GridDefault3Component } from './components/grid-default-3/grid-default-3.component';
import { GridLastSizesComponent } from './components/grid-last-sizes/grid-last-sizes.component';
import { GridNewCollectionComponent } from './components/grid-new-collection/grid-new-collection.component';
import { GridStudioComponent } from './components/grid-studio/grid-studio.component';
import { StudioTemplatesModule } from './components/studio-templates/studio-templates.module';
import { CategoryPageStylesDirective } from './directives/category-page-styles.directive';
import { CategoryGridComponent } from './layout/category-grid.component';
import { CategoryGridService } from './services/category-grid.service';
import { CategoryGridEffects } from './store/category-grid.effects';
import { CategoryGridReducer } from './store/category-grid.reducer';
import { NewCollectionGridEffects } from './store/new-collection-grid.effects';

import { CoreStorageService } from '@core/infrastructure/storage/storage.service';
import { ProductsArrayFeaturePublicApi } from '@features/products/productsArray';
import { CategoryNavComponent } from '@pages/category/components/category-nav/category-nav.component';
import { CategoryNoresultsComponent } from '@pages/category/components/category-noresults/category-noresults.component';
import {
    CustomCategoryGridService,
} from '@pages/category/modules/grid-custom-category/services/custom-category-grid.service';
import { GridTypeViewService } from '@pages/category/services/grid-type-view.service';
import { CategoryToolbarModule } from '@shared/category-toolbar/category-toolbar.module';
import { PricesModule } from '@shared/prices/prices.module';
import { AddToCartBottomSheetComponent } from '@shared/product/components/add-to-cart-bottom-sheet/add-to-cart-bottom-sheet.component';
import { ProductViewComponent } from '@shared/product/components/product-view/product-view.component';
import { ProductModule } from '@shared/product/product.module';
import { RelatedProductsCoreModule } from '@shared/product/related-products/related-products-core.module';

@NgModule({
    imports: [
        AddToCartBottomSheetComponent,
        CategoryNavComponent,
        CategoryNoresultsComponent,
        CategoryToolbarModule,
        CommonModule,
        TranslateModule.forChild(),
        CommonModule,
        GridDefault2Component,
        GridLastSizesComponent,
        InfiniteScrollModule,
        MdIconComponent,
        TranslateModule.forChild(),
        PricesModule,
        ProductModule,
        ProductViewComponent,
        RelatedProductsCoreModule,
        StudioTemplatesModule,
    ],
    declarations: [
        CategoryGridComponent,
        CategoryPageStylesDirective,
        GridDefault3Component,
        GridNewCollectionComponent,
        GridStudioComponent,
    ],
    providers: [
        provideState({ name: 'category-grid', reducer: CategoryGridReducer }),
        provideEffects(CategoryGridEffects, CustomCategoryGridEffects, NewCollectionGridEffects),
        CategoryGridService,
        CoreStorageService,
        CustomCategoryGridService,
        GridTypeViewService,
        ProductsArrayFeaturePublicApi,
    ],
    exports: [
        CategoryGridComponent,
        CategoryPageStylesDirective,
    ],
})

export class CategoryGridModule { }
